import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from '../../../group_leader/components/common'
import { makeT } from '../../../group_leader/helpers/i18n'
import { rankOf } from '../../helpers/results'

const t = makeT('group_leader.event_results.leaderboard')

// Medals for the top three by the blob's rank; the position is always text, the colour reinforces it.
const TONE_BY_RANK = { 1: 'gold', 2: 'silver', 3: 'bronze' }

const PositionBadge = ({ entry }) => {
  // No position in the blob means the engine did not rank this board; a row number would invent one.
  const position = entry.position || entry.pos
  if (!position) { return null }

  return (
    <Badge
      shape="circle"
      tone={TONE_BY_RANK[rankOf(position)] || 'neutral'}
      ariaLabel={t('position_aria', { pos: position })}
      >
      {position}
    </Badge>
  )
}

PositionBadge.propTypes = {
  entry: PropTypes.object.isRequired,
}

export default PositionBadge
